export function nameForCriticality(criticality: $TSFixMe, intl: $TSFixMe) {
  return intl.formatMessage({
    id: `insights.criticality.${criticality.toLowerCase()}`,
  });
}

export function intlAdjectiveForCriticality(
  criticality: $TSFixMe,
  intl: $TSFixMe,
) {
  return nameForCriticality(`${criticality.toLowerCase()}.adjective`, intl);
}

export function nameForSelections(
  selectionName: $TSFixMe,
  optionName: $TSFixMe,
  intl: $TSFixMe,
) {
  return intl.formatMessage({
    id: `${selectionName}.${optionName.toLowerCase()}`,
  });
}
